const BASE_URL = 'https://dev-vini-mall.5t1800.com'
const dev_BASE_URL = 'https://www.fastmock.site/mock/6e0d1ef1f46b31d09aebb7ae65871378/userList'

export default {
    BASE_URL,
    dev_BASE_URL
}